import { useEffect } from 'react';
import { useEditor } from './useEditor';
import { useScene } from './useScene';

export const uiHooks = () => {
  const { UI, setUI } = useEditor();
  const scene = useScene();

  const applyTheme = (themeName: string) => {
    document.documentElement.className = themeName;
  };
  useEffect(() => applyTheme(UI.theme), [UI.theme]);

  // Show sidebar when Element is selected
  useEffect(() => {
    const isVisible = scene.selectedElementIDs.length > 0;
    setUI((UI) => ({ ...UI, isSidebarVisible: isVisible }));
  }, [scene.selectedElementIDs]);
};
